/** 商业智能管理路由 */
// import Layout from '@/wkcrmViews/layout/BiLayout'
// const layout = function(path: string, alwaysShow: boolean, meta: any) {
//   return {
//     path: path,
//     // component: Layout,
//     alwaysShow: alwaysShow,
//     meta: {
//       requiresAuth: true,
//       ...meta
//     }
//   };
// };
export default [
// {
//   ...layout('/bi/customer', true, {
//     permissions: ['bi', 'customer'],
//     icon: 'icon-customer-a-line',
//     title: '员工客户分析'
//   }),
//   children: [
//     {
//       path: 'total', // 客户总量分析
//       component: () => import('@/wkcrmViews/bi/customer/CustomerTotalStatistics.vue'),
//       meta: {
//         title: '客户总量分析'
//       }
//     },
//     {
//       path: 'record', // 客户跟进次数分析
//       component: () => import('@/wkcrmViews/bi/customer/CustomerRecordStatistics.vue'),
//       meta: {
//         title: '客户跟进次数分析'
//       }
//     },
//     // {
//     //   path: 'recordmode', // 客户跟进方式分析
//     //   component: () => import('@/wkcrmViews/bi/customer/CustomerRecordModeStatistics.vue'),
//     //   meta: {
//     //     title: '客户跟进方式分析'
//     //   }
//     // },
//     {
//       path: 'conversion', // 客户转化率分析
//       component: () => import('@/wkcrmViews/bi/customer/CustomerConversionStatistics.vue'),
//       meta: {
//         title: '客户转化率分析'
//       }
//     },
//     {
//       path: 'pool', // 公海客户分析
//       component: () => import('@/wkcrmViews/bi/customer/CustomerPoolStatistics.vue'),
//       meta: {
//         title: '公海客户分析'
//       }
//     },
//     {
//       path: 'cycle', // 成交周期分析
//       component: () => import('@/wkcrmViews/bi/customer/CustomerCycleStatistics.vue'),
//       meta: {
//         title: '成交周期分析'
//       }
//     },
//     {
//       path: 'customerSatisfaction', // 员工客户满意度分析
//       component: () => import('@/wkcrmViews/bi/customer/CustomerSatisfaction.vue'),
//       meta: {
//         title: '员工客户满意度分析'
//       }
//     },
//     {
//       path: 'productSatisfaction', // 产品满意度分析
//       component: () => import('@/wkcrmViews/bi/customer/ProductSatisfaction.vue'),
//       meta: {
//         title: '产品满意度分析'
//       }
//     }
//   ]
// },
// {
//   ...layout('/bi/business', true, {
//     permissions: ['bi', 'business'],
//     icon: 'screening',
//     title: '销售漏斗分析'
//   }),
//   children: [
//     {
//       path: 'funnel', // 销售漏斗
//       component: () => import('@/wkcrmViews/bi/business/FunnelStatistics.vue'),
//       meta: {
//         title: '销售漏斗'
//       }
//     },
//     {
//       path: 'addBusiness', // 新增商机分析
//       component: () => import('@/wkcrmViews/bi/business/BusinessTrendStatistics.vue'),
//       meta: {
//         title: '新增商机分析'
//       }
//     },
//     {
//       path: 'conversion', // 商机转化率分析
//       component: () => import('@/wkcrmViews/bi/business/BusinessWinStatistics.vue'),
//       meta: {
//         title: '商机转化率分析'
//       }
//     }
//   ]
// },
// {
//   ...layout('/bi/contract', true, {
//     permissions: ['bi', 'contract'],
//     icon: 'hollow-results',
//     title: '员工业绩分析'
//   }),
//   children: [
//     {
//       path: 'count', // 合同数量分析
//       component: () => import('@/wkcrmViews/bi/achievement/AchievementCountStatistics.vue'),
//       meta: {
//         title: '合同数量分析'
//       }
//     },
//     {
//       path: 'money', // 合同金额分析
//       component: () => import('@/wkcrmViews/bi/achievement/AchievementMoneyStatistics.vue'),
//       meta: {
//         title: '合同金额分析'
//       }
//     },
//     {
//       path: 'backMoney', // 回款金额分析
//       component: () => import('@/wkcrmViews/bi/achievement/AchievementBackStatistics.vue'),
//       meta: {
//         title: '回款金额分析'
//       }
//     },
//     {
//       path: 'summary', // 合同汇总表
//       component: () => import('@/wkcrmViews/bi/achievement/AchievementSummaryStatistics.vue'),
//       meta: {
//         title: '合同汇总表'
//       }
//     },
//     {
//       path: 'invoice', // 发票统计分析
//       component: () => import('@/wkcrmViews/bi/achievement/AchievementInvoiceStatistics.vue'),
//       meta: {
//         title: '发票统计分析'
//       }
//     }
//   ]
// },
// {
//   ...layout('/bi/portrait', true, {
//     permissions: ['bi', 'portrait'],
//     icon: 'percent-line',
//     title: '客户画像分析'
//   }),
//   children: [
//     {
//       path: 'address', // 城市分布分析
//       component: () => import('@/wkcrmViews/bi/customerPortrayal/CustomerAddressStatistics.vue'),
//       meta: {
//         title: '城市分布分析'
//       }
//     }, {
//       path: 'customer/:type', // 客户分析
//       hidden: true, // 菜单不展示
//       component: () => import('@/wkcrmViews/bi/customerPortrayal/CustomerPortrayalStatistics.vue')
//     },
//     {
//       path: 'customer/industry', // 客户行业分析
//       component: () => import('@/wkcrmViews/bi/customerPortrayal/CustomerPortrayalStatistics.vue'),
//       ignore: true, // 路由添加时忽略
//       meta: {
//         title: '客户行业分析'
//       }
//     },
//     {
//       path: 'customer/level', // 客户级别分析
//       component: () => import('@/wkcrmViews/bi/customerPortrayal/CustomerPortrayalStatistics.vue'),
//       ignore: true, // 路由添加时忽略
//       meta: {
//         title: '客户级别分析'
//       }
//     },
//     {
//       path: 'customer/source', // 客户来源分析
//       component: () => import('@/wkcrmViews/bi/customerPortrayal/CustomerPortrayalStatistics.vue'),
//       ignore: true, // 路由添加时忽略
//       meta: {
//         title: '客户来源分析'
//       }
//     }
//   ]
// },
// {
//   ...layout('/bi/product', true, {
//     permissions: ['bi', 'product'],
//     icon: 'product-line',
//     title: '产品分析'
//   }),
//   children: [
//     {
//       path: 'sales', // 产品销售情况统计
//       component: () => import('@/wkcrmViews/bi/product/ProductStatistics.vue'),
//       meta: {
//         title: '产品销售情况统计'
//       }
//     },
//     {
//       path: 'category', // 产品分类销量分析
//       component: () => import('@/wkcrmViews/bi/product/ProductCategoryStatistics.vue'),
//       meta: {
//         title: '产品分类销量分析'
//       }
//     }
//     // {
//     //   path: 'business', // 产品商机情况统计
//     //   component: () => import('@/wkcrmViews/bi/product/ProductBusinessStatistics.vue'),
//     //   meta: {
//     //     title: '产品商机情况统计'
//     //   }
//     // }
//   ]
// },
// {
//   ...layout('/bi/call', true, {
//     permissions: ['bi', 'call'],
//     icon: 'wk wk-phoneing',
//     title: '呼叫中心'
//   }),
//   children: [
//     {
//       path: 'callDetail', // 通话详情
//       component: () => import('@/wkcrmViews/bi/callCenter/CallTalkCount.vue'),
//       meta: {
//         title: '员工通话记录统计分析'
//       }
//     }, {
//       path: 'callCount', // 通话记录
//       component: () => import('@/wkcrmViews/bi/callCenter/CallDetailsStatistics.vue'),
//       meta: {
//         title: '员工通话记录'
//       }
//     }
//   ]
// },
// {
//   ...layout('/bi/ranking', true, {
//     permissions: ['bi', 'ranking'],
//     icon: 'icon-ranking-list',
//     title: '排行榜'
//   }),
//   children: [
//     {
//       path: 'contract', // 合同金额排行
//       component: () => import('@/wkcrmViews/bi/ranking/RankingContractStatistics.vue'),
//       meta: {
//         title: '合同金额排行'
//       }
//     },
//     {
//       path: 'receivables', // 回款金额排行
//       component: () => import('@/wkcrmViews/bi/ranking/RankingReceivablesStatistics.vue'),
//       meta: {
//         title: '回款金额排行'
//       }
//     },
//     {
//       path: 'signing', // 签约合同排行
//       component: () => import('@/wkcrmViews/bi/ranking/RankingSigningStatistics.vue'),
//       meta: {
//         title: '签约合同排行'
//       }
//     },
//     {
//       path: 'product', // 产品销量排行
//       component: () => import('@/wkcrmViews/bi/ranking/RankingProductStatistics.vue'),
//       meta: {
//         title: '产品销量排行'
//       }
//     },
//     {
//       path: 'addCustomer', // 新增客户数排行
//       component: () => import('@/wkcrmViews/bi/ranking/RankingAddCustomerStatistics.vue'),
//       meta: {
//         title: '新增客户数排行'
//       }
//     },
//     {
//       path: 'addContacts', // 新增联系人数排行
//       component: () => import('@/wkcrmViews/bi/ranking/RankingAddContactsStatistics.vue'),
//       meta: {
//         title: '新增联系人数排行'
//       }
//     },
//     {
//       path: 'recordNun', // 跟进次数排行
//       component: () => import('@/wkcrmViews/bi/ranking/RankingRecordNunStatistics.vue'),
//       meta: {
//         title: '跟进次数排行'
//       }
//     },
//     {
//       path: 'recordCustomer', // 跟进客户数排行
//       component: () => import('@/wkcrmViews/bi/ranking/RankingRecordCustomerStatistics.vue'),
//       meta: {
//         title: '跟进客户数排行'
//       }
//     },
//     {
//       path: 'examine', // 出差次数排行
//       component: () => import('@/wkcrmViews/bi/ranking/RankingExamineStatistics.vue'),
//       meta: {
//         title: '出差次数排行'
//       }
//     }
//   ]
// },
// {
//   ...layout('/bi/oa', true, {
//     permissions: ['bi', 'oa'],
//     icon: 'icon-office-line',
//     title: '办公分析'
//   }),
//   children: [
//     {
//       path: 'log', // 日志分析
//       component: () => import('@/wkcrmViews/bi/oa/Log.vue'),
//       meta: {
//         title: '日志分析'
//       }
//     },
//     {
//       path: 'examine', // 审批分析
//       component: () => import('@/wkcrmViews/bi/oa/Examine.vue'),
//       meta: {
//         title: '审批分析'
//       }
//     }
//   ]
// },
// {
//   ...layout('/bi/target', false, {
//     permissions: ['bi', 'achievement']
//   }),
//   children: [
//     {
//       path: 'complete', // 业绩目标完成情况
//       component: () => import('@/wkcrmViews/bi/TaskCompleteStatistics.vue'),
//       meta: {
//         icon: 'icon-target2',
//         title: '业绩目标完成情况'
//       }
//     }
//   ]
// }
];
